'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormContainer = require('./FormContainer');

var _FormContainer2 = _interopRequireDefault(_FormContainer);

var _actions = require('../LoadingContainer/actions');

var _actions2 = require('../SnackBarContainer/actions');

var _AppBarSetter = require('../DrawerMenuContainer/AppBarSetter');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseForm = function (_React$Component) {
  _inherits(BaseForm, _React$Component);

  function BaseForm(props, context) {
    _classCallCheck(this, BaseForm);

    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props, context));

    _this.onSuccess = props.onSuccess;
    _this.request = props.request;
    _this.FormContainer = (0, _FormContainer2.default)({
      name: props.name,
      groups: props.config.groups
    });
    _this.config = (0, _util.merge)(props.config, { initialValues: props.initialValues });
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onCancel = _this.onCancel.bind(_this);
    return _this;
  }

  _createClass(BaseForm, [{
    key: 'onCancel',
    value: function onCancel() {
      this.context.store.dispatch((0, _reactRouterRedux.goBack)());
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(values) {
      var _this2 = this;

      var _props = this.props,
          onSubmit = _props.onSubmit,
          onSuccess = _props.onSuccess,
          id = _props.id,
          selectedObject = _props.selectedObject;

      values = onSubmit ? onSubmit(values, selectedObject) : values;

      var dispatch = this.context.store.dispatch;

      dispatch((0, _actions.setVisibility)(true));
      this.request(values, id).then(function (result) {
        if (onSuccess) {
          onSuccess(result, dispatch, _this2.props, _this2.context.store.getState());
        }
        dispatch((0, _actions2.setSuccessSnackBar)());
      }).catch(function () {
        dispatch((0, _actions2.setErrorSnackBar)());
      }).finally(function () {
        dispatch((0, _actions.setVisibility)(false));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var FormContainer = this.FormContainer;

      return _react2.default.createElement(FormContainer, _extends({
        onCancel: this.onCancel,
        onSubmit: this.onSubmit,
        confirmExit: this.props.confirmExit,
        submitDisabled: this.props.submitDisabled
      }, this.config));
    }
  }]);

  return BaseForm;
}(_react2.default.Component);

BaseForm.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  id: _react2.default.PropTypes.number,
  selectedObject: _react2.default.PropTypes.any,
  name: _react2.default.PropTypes.string.isRequired,
  confirmExit: _react2.default.PropTypes.bool,
  submitDisabled: _react2.default.PropTypes.bool,
  initialValues: _react2.default.PropTypes.object,
  request: _react2.default.PropTypes.func.isRequired,
  onSubmit: _react2.default.PropTypes.func,
  onSuccess: _react2.default.PropTypes.func,
  config: _react2.default.PropTypes.object.isRequired
};
BaseForm.contextTypes = {
  store: _react2.default.PropTypes.object.isRequired
};
BaseForm.defaultProps = {
  confirmExit: false,
  submitDisabled: false,
  initialValues: {}
};
exports.default = (0, _reactIntl.injectIntl)((0, _AppBarSetter.injectAppBarSetter)(BaseForm));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/FormContainer/BaseForm.js
 ** module id = 127
 ** module chunks = 0
 **/